import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead, Tooltip } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import styled from 'styled-components'
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import { useSelector } from 'react-redux'
import moment from 'moment';
import { useGetAssetsQuery, useUpdateAddAssetStatusMutation, useDeleteAssetMutation } from '../../../../features/addassets/addassetApiSlice'
import { useAddNewAssetFinalMutation } from "../../../../features/addassets/addassetfinalApiSlice"
import { TableContStyle, TableHeadStyle } from '../../../../Styles/TableStyles'
import useAuth from '../../../../features/hooks/useAuth'
import Popup from 'reactjs-popup';
import { PopupButton } from '../../../../Styles/CommonStyles'
import { useGetconsumablesQuery } from '../../../../features/consumable/consumableApiSlice';


const StatusButton = styled.button`
width: 80px;
height: 30px;
padding: 5px 7px;
border: none;
border-radius:10px ;
background-color: ${({ type }) => {
    if (type === "approved") {
      return "lightgreen";
    }
    else if (type === "appByLev1") {
      return "#FCCB00";
    }
    else if (type === "draft") {
      return "#D32F2F";
    }
  }};
color: ${({ type }) => {
    if (type === "approved") {
      return "white";
    }
    else if (type === "appByLev1") {
      return "black";
    }
    else if (type === "draft") {
      return "lightgreen";
    }
  }};
`
const StyledIconButton = styled(IconButton)`
margin: 5px;
`
const ActionIconContainer = styled.div``
const StyledPreviewIcon = styled(VisibilityIcon)``
const StyledEditIcon = styled(EditIcon)``
const StyledDeleteIcon = styled(DeleteIcon)``
const SignIconContainer = styled.div``
const StyledSignIcon = styled(DesignServicesIcon)``
const SignButtonContainer = styled.div``

const DetailsCont = styled.div``
const DetailsWrapper = styled.div``
const DetailsItemWrap = styled.div`
display: flex;
flex-direction: column;
padding: 5px;
border: 2px solid black;
border-radius: 10px;
background-color: #97bcd5;
margin-top: 5px;
`
const NameRoleWrap = styled.div`
  display: flex;
justify-content: space-between;
`
const ItemWrapper = styled.div`
display: flex;
`
const KeyWrap = styled.div`
font-weight: bold;
margin-right: 10px;
`
const ValueWrap = styled.div``
const StyledPopup = styled(Popup)``


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function SubmittedTable({ handleSubmitEditclick }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isPopupOpen, setIsPopupOpen] = useState(false);


  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]

  //fetch all addasset documents for appraoval
  const {
    data: assets,
    isLoading,
    isSuccess,
    isError,
    error
  } = useGetAssetsQuery('assets', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  const { addconsumable } = useGetconsumablesQuery('userslist', {
    selectFromResult: ({ data }) => ({
      addconsumable: data?.entities
    }),
  });

  const { getasset } = useGetAssetsQuery('assets', {
    selectFromResult: ({ data }) => ({
      getasset: data?.entities
    }),
  })

  const [deleteAsset, { isLoading: deleteAssetloading }] = useDeleteAssetMutation()

  let tempdata = addconsumable ? Object.values(addconsumable) : []

  let tabledata = tempdata.filter(elm => elm.addstatus === 'submitted')

  const [addNewAssetFinal, { isLoading: newassetfinalloading }] = useAddNewAssetFinalMutation()
  const [updateAddAssetStatus, { isLoading: statusfinalloading }] = useUpdateAddAssetStatusMutation()


  const handleDelete = async (Id) => {
    try {
      let body = { id: Id }
      const res = await deleteAsset(body);
      console.log(res)
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  const rows = tabledata  

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      <Table sx={{ minWidth: 50 }} aria-label="custom pagination table">
        <TableHead>
          <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor }}>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">S.No</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Asset Name</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Order No</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Part No.</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Quantity</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Unit Cost</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">OEM/Vendor</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Date of Purchase</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Status</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Actions</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ).map((row, index) => (
            <TableRow key={index}>
              <TableCell style={{ width: 5 }} component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.consumable}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.orderno}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.partno}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.order_quantity}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.unit_price}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.oem}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {moment(row.purchase_date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                <StatusButton type={row.status}>{row.status}</StatusButton>
              </TableCell>
              <TableCell style={{ width: 200 }} align="left">
                <ActionIconContainer>
                  <Tooltip title="Preview">
                    <StyledIconButton onClick={(e) => handleSubmitEditclick(e,'clicked', row._id)} color="primary" size='small'>
                       <StyledPreviewIcon />
                    </StyledIconButton>
                  </Tooltip>
                  {row.curr_editstatus === true && <Tooltip title="Edit">
                    <StyledIconButton onClick={(e) => handleSubmitEditclick(e,'clicked', row._id)}  color="primary" size='small'>
                      <StyledEditIcon />
                    </StyledIconButton>
                  </Tooltip>}
                  <Tooltip title="Delete">
                    <StyledIconButton disabled={["appByLev1", "approved"].includes(row.status)} onClick={() => handleDelete(row._id)} color="primary" size='small'>
                      <StyledDeleteIcon />
                    </StyledIconButton>
                  </Tooltip>
                </ActionIconContainer>
              </TableCell>
              <TableCell style={{ width: 100 }} align="right">
                <div className="dropdown-container" style={{ width: '100px' }} >
                  <StyledPopup
                    trigger={
                      <PopupButton style={{ width: 100 }} className="button"> Details </PopupButton>}
                    modal
                    nested
                    open={isPopupOpen}
                    onClose={() => setIsPopupOpen(false)}
                    contentStyle={{width: '600px', maxHeight: 'auto', overflowY: 'auto' }}
                  >
                    < DetailsCont>
                      <DetailsWrapper>
                        {row.flow_data?.map((elm, ind) => <DetailsItemWrap key={ind}>
                          <NameRoleWrap>
                            <ItemWrapper>
                              <KeyWrap>Role:</KeyWrap>
                              <ValueWrap>{elm.person_details.role}</ValueWrap>
                            </ItemWrapper>
                            <ItemWrapper>
                              <KeyWrap>User Details:</KeyWrap>
                              <ValueWrap>{`${elm.person_details.name.firstName} ${elm.person_details.name.middleName} ${elm.person_details.name.lastName}- ${elm.person_details.designation}`}</ValueWrap>
                            </ItemWrapper>
                          </NameRoleWrap>
                          <ItemWrapper>
                            <KeyWrap>Status:</KeyWrap>
                            <ValueWrap>{elm.status}</ValueWrap>
                          </ItemWrapper>
                          {elm.remarks.length > 0 && <ItemWrapper>
                            <KeyWrap>Remark:</KeyWrap>
                            <ValueWrap>{elm.remarks}</ValueWrap>
                          </ItemWrapper>}
                          {elm.editstatus && <ItemWrapper>
                            <KeyWrap>Returned to modify:</KeyWrap>
                            <ValueWrap>{elm.editstatus && 'YES'}</ValueWrap>
                          </ItemWrapper>}
                        </DetailsItemWrap>)}
                      </DetailsWrapper>
                    </DetailsCont>
                  </StyledPopup>
                </div>
              </TableCell>
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={9}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
